<template>
  <b-container>
    <b-row>
      <b-col>
        <b-tabs lazy>
          <b-tab :title="$t('globals.daily')" title-link-class="text-info">
            <ulu-defined-range-tab
              :currentRange="getTodayRange"
              :pastRange="getYesterdayRange"
            />
          </b-tab>
          <b-tab :title="$t('globals.weekly')" title-link-class="text-info">
            <ulu-defined-range-tab
              :currentRange="getThisWeekRange"
              :pastRange="getLastWeekRange"
            />
          </b-tab>
          <b-tab :title="$t('globals.monthly')" title-link-class="text-info">
            <ulu-defined-range-tab
              :currentRange="getThisMonthRange"
              :pastRange="getLastMonthRange"
            />
          </b-tab>
          <b-tab :title="$t('globals.quarterly')" title-link-class="text-info">
            <ulu-defined-range-tab
              :currentRange="getThisQuarterRange"
              :pastRange="getLastQuarterRange"
            />
          </b-tab>
          <b-tab :title="$t('globals.yearly')" title-link-class="text-info">
            <ulu-defined-range-tab
              :currentRange="getThisYearRange"
              :pastRange="getLastYearRange"
            />
          </b-tab>
          <b-tab :title="$t('globals.range')" title-link-class="text-info">
            <ulu-range-overview-card
              v-if="getUserBrandPermissions.kpi_devices"
              class="m-1"
              style="max-width: 500px"
            />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    "ulu-defined-range-tab": () =>
      import("@/components/dashboard/highlights/DefinedRangeTab"),
    "ulu-range-overview-card": () =>
      import("@/components/dashboard/highlights/HighlightsRangeOverview")
  },
  data() {
    return {
      
    };
  },
  computed: {
    ...mapGetters([
      "getUserBrandPermissions",
      "getTodayRange",
      "getYesterdayRange",
      "getThisWeekRange",
      "getLastWeekRange",
      "getThisMonthRange",
      "getLastMonthRange",
      "getThisYearRange",
      "getLastYearRange",
      "getThisQuarterRange",
      "getLastQuarterRange"
    ])
  }
};
</script>
